import { Component } from '@angular/core';

@Component({
  selector: 'app-sellers-data-empty',
  templateUrl: './sellers-data-empty.component.html',
  styleUrls: ['./sellers-data-empty.component.scss']
})
export class SellersDataEmptyComponent {

}
